import { ExportOutlined, QrcodeOutlined } from '@ant-design/icons'
import { Button, Modal, Spin, Tooltip } from 'antd'
import QRCode from 'qrcode.react'
import React from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import { firestoreConnect } from 'react-redux-firebase'
import { withHandlers, withState } from 'recompose'
import { compose } from 'redux'
import { v4 as uuid } from 'uuid'

import { fsCollections } from '../../helpers/firestore'
import routes from '../../helpers/routes'
import './DevicePairing.css'

class PairingModal extends React.Component<any, any> {
  componentDidMount() {
    const { firestore, tenant, tournamentId, flightId, setSecret } = this.props
    const pairingDocRef = {
      collection: fsCollections.pairings(tenant, tournamentId),
      doc: flightId,
    }

    firestore.get(pairingDocRef).then((doc) => {
      if (doc.exists) {
        setSecret(doc.data().secret)
      } else {
        const secret = uuid()
        firestore.set(pairingDocRef, { secret }).then(() => setSecret(secret))
      }
    })
  }

  render() {
    const { visible, hide, tenant, tournamentId, flightId, secret } = this.props
    const qrTargetUrl =
      // TODO fix:tslint below
      // tslint:disable-next-line:prefer-template
      window.location.origin + routes.flightResults(tenant, tournamentId, flightId) + '#' + secret
    const content = secret ? (
      <div>
        <QRCode value={qrTargetUrl} level="M" />

        {/*
         * We don't want to provide a link, as if an admin actually opened it, he would authorize
         * himself for flight result writes (which we don't want in production). Still, it's kind
         * of handy for testing to get easy access to the link. Hence - copy to clipboard :)
         */}
        <span className="copy-to-clipboard">
          <CopyToClipboard text={qrTargetUrl}>
            <ExportOutlined />
          </CopyToClipboard>
        </span>
      </div>
    ) : (
      <Spin size="large" />
    )

    return (
      <Modal
        title="Pair Device"
        visible={visible}
        onCancel={hide}
        footer={
          <Button key="close" onClick={hide}>
            Close
          </Button>
        }>
        {content}
      </Modal>
    )
  }
}

const EnhancedPairingModal = compose<FIXME>(
  withState('secret', 'setSecret', null),
  firestoreConnect<FIXME>(({ tenant, tournamentId }) => [
    { collection: fsCollections.pairings(tenant, tournamentId) },
  ]),
)(PairingModal)

const DevicePairing = (props) => {
  const { modalVisible, showModal, hideModal, buttonSize } = props

  return (
    <React.Fragment>
      <Tooltip title="Enroll device">
        <Button size={buttonSize} icon={<QrcodeOutlined />} onClick={showModal} />
      </Tooltip>
      {modalVisible && <EnhancedPairingModal {...props} visible hide={hideModal} />}
    </React.Fragment>
  )
}

export default compose<any>(
  withState('modalVisible', 'setModalVisible', false),
  withHandlers({
    hideModal: ({ setModalVisible }) => () => setModalVisible(false),
    showModal: ({ setModalVisible }) => () => setModalVisible(true),
  }),
)(DevicePairing)



// WEBPACK FOOTER //
// ./src/components/flights/DevicePairing.tsx